import { Controller } from '@hotwired/stimulus';

// Auto-dismiss is opt-in per use: warnings and errors should stay until read.
export default class extends Controller {
  static values = { autoDismissSeconds: Number };

  connect() {
    if (this.autoDismissSecondsValue > 0) {
      this.timeout = setTimeout(() => this.close(), this.autoDismissSecondsValue * 1000);
    }
  }

  disconnect() {
    clearTimeout(this.timeout);
  }

  close() {
    this.dispatch('closed');
    this.element.remove();
  }
}
